'use client';

import type { ReactNode } from 'react';
import type { FlaunchAdapter } from '../../data/mock-adapters';
import { AdapterPanelShell, Stat, StatGrid2 } from './AdapterPanelShell';

/**
 * Flaunch adapter panel.
 *
 * Flaunch coins fund seat rewards via auto-buybacks of the launched coin.
 * The panel exposes TVL and the coin symbol — the bare minimum a viewer
 * needs to understand "what's funding the yield". The Accrued column was
 * removed (see the yield-panel refresh) because mid-card it doubled with
 * the per-tile accrued amount in `RewardsPanel`, which is the canonical
 * "what have I earned" surface; surfacing both here muddied the read.
 * The Uniswap v3 / v4 panels mirror this 2-stat layout so every adapter
 * card reads identically — only the brand icon changes.
 */
export function FlaunchAdapterPanel({
  adapter,
  belowStats,
}: {
  adapter: FlaunchAdapter;
  belowStats?: ReactNode;
}) {
  return (
    <AdapterPanelShell adapter={adapter} belowStats={belowStats}>
      <StatGrid2>
        <Stat label="TVL" value={adapter.tvlUsd} />
        <Stat label="Coin" value={adapter.coinSymbol} />
      </StatGrid2>
    </AdapterPanelShell>
  );
}
